import React, { useState } from "react";
import PropTypes from "prop-types";

import Search from "core/ReusableIcons/Search";
import colors from "core/colors";
import { SearchInput, SubmitButton } from "./styles";

import { searchURLPath } from "./helpers";
import { useUrlQuery } from "ssr/helpers";

const HeaderSearch = ({ placeholder, selectedSearchType }) => {
    const params = useUrlQuery();
    const initialQuery = params.q || "";

    const [query, setQuery] = useState(initialQuery);

    const handleInputChange = e => {
        setQuery(e.target.value);
    };

    const searchPath = searchURLPath({
        currentPath:
            typeof window !== "undefined" ? window.location.pathname : "/",
        searchType: selectedSearchType
    });

    // TODO: As a future optimization, we might want to override the form's submit
    // handler and use react-router instead of letting the HTML form sumbit and
    // cause a page reload. Once icons and photos are in the same router, that will
    // be a lot easier. If we want to do it before that, we'll need to use the HTML
    // form every time someone does an icon search on a photo page, or vice versa.

    return (
        <form action={searchPath}>
            <SearchInput
                aria-label="Search term"
                name="q"
                placeholder={placeholder}
                value={query || ""}
                onChange={handleInputChange}
            />
            <SubmitButton
                isSubmit
                aria-label="Submit search term"
                isDisabled={!query}
            >
                <Search fillColor={colors.primary.diamond} size="md" />
            </SubmitButton>
        </form>
    );
};

HeaderSearch.propTypes = {
    placeholder: PropTypes.string,
    selectedSearchType: PropTypes.string
};

export default HeaderSearch;
